import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ShopOrderApi } from 'api';
import type { ShopOrder } from 'api/methods/ShopOrderApi';

/**
 * [ShopOrder] Query key 생성
 * --
 */
export const shopOrderQueryKeys = createQueryKeys('shop_order', {
  getShopOrder: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getShopOrders: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [ShopOrder] 매장 메뉴 내역 전체 조회
 * --
 */
export const useGetShopOrders = (
  params?: {
    [key: string]: string | number;
  },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: shopOrderQueryKeys.getShopOrders(params).queryKey,
    queryFn: () => ShopOrderApi.getShopOrders(params),
    ...options,
  });
  return data;
};

/**
 * [ShopOrder] 매장 메뉴 내역 상세 조회
 * --
 */
export const useGetShopOrder = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: shopOrderQueryKeys.getShopOrder(idx, params).queryKey,
    queryFn: () => ShopOrderApi.getShopOrder(idx, params),
    ...options,
  });

  return data;
};

/**
 * [ShopOrder] 매장 메뉴 내역 생성
 * --
 */
export const useCreateShopOrder = (body: ShopOrder) => {
  const { mutateAsync: createShopOrder, ...result } = useMutation({
    mutationFn: (variables: ShopOrder) =>
      ShopOrderApi.createShopOrder(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createShopOrder, ...result };
};

/**
 * [ShopOrder] 매장 메뉴 내역 수정
 * --
 */
export const useUpdateShopOrder = (body: ShopOrder) => {
  const { mutateAsync: updateShopOrder, ...result } = useMutation({
    mutationFn: (variables: ShopOrder) =>
      ShopOrderApi.updateShopOrder(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateShopOrder, ...result };
};

/**
 * [ShopOrder] 매장 메뉴 내역 삭제
 * --
 */
export const useDeleteShopOrder = (idx: number) => {
  const { mutateAsync: deleteShopOrder, ...result } = useMutation({
    mutationFn: (variables: number) => ShopOrderApi.deleteShopOrder(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteShopOrder, ...result };
};

/**
 * [ShopOrder] 매장 메뉴 내역 생성
 * --
 */
export const useCreateManualShopOrder = () => {
  const { mutateAsync: createManualShopOrder, ...result } = useMutation({
    mutationFn: (variables: ShopOrder) =>
      ShopOrderApi.createManualShopOrder(variables),
  });

  return { createManualShopOrder, ...result };
};
